export default class OneBusinessError extends Error {
  constructor(message: string, cause?: unknown) {
    super(message, { cause });

    Object.setPrototypeOf(this, OneBusinessError.prototype);
  }
}
